import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useControlStore = defineStore('control', () => {
    // #region STATE

    const grids = ref([]);
    const activeGrid = ref([]);
    const activeTabId = ref(null);
    const controls = ref({});
    const checkAllUpdate = ref(false);
    const rail = ref(false);

    // #endregion

    // #region GRID
    
    function removeActiveGrids(grid) {
        const index = grids.value.indexOf(grid);
        if(index > -1){
            grids.value.splice(index, 1);
        }
    }

    function undoAll() {
        const gridApi = getDisplayedGrid().api;

        for (let i = 0; i < gridApi.getCurrentUndoSize() + 1; i++)
            setTimeout(() => {
                gridApi.undoCellEditing();
            }, 10 * i);

        gridApi.redrawRows();
    }

    function checkAll(gridApi, field, isChecked) {
        checkAllUpdate.value = true;

        const rowData = [];

        gridApi.forEachLeafNode((node) => {
            node.data[field] = isChecked;
            rowData.push(node.data);
        });

        gridApi.applyTransaction({
            update: rowData,
        });

        setTimeout(() => {
            checkAllUpdate.value = false;
        }, 1000);
    }

    // #endregion

    // #region TABS

    function setActiveTab(newActiveTabId) {
        activeTabId.value = newActiveTabId;
    }

    function getActiveTab() {
        return activeTabId.value;
    }

    // #endregion

    // #region ACTIVE CUSTOMER / DISTRIBUTOR

    function getActiveCustomer() {
        const value = localStorage.getItem('activeCustomer');
        return value ? JSON.parse(value) : null;
    }

    function setActiveCustomer(customer) {
        localStorage.setItem('activeCustomer', customer ? JSON.stringify(customer) : null);
    }

    function getActiveDistributor() {
        const value = localStorage.getItem('activeDistributor');
        return value ? JSON.parse(value) : null;
    }

    function setActiveDistributor(distributor) {
        localStorage.setItem('activeDistributor', distributor ? JSON.stringify(distributor) : null);
    }

    // #endregion

    return {
        // state
        grids,
        activeGrid,
        activeTabId,
        controls,
        checkAllUpdate,
        rail,
        // grid
        removeActiveGrids,
        undoAll,
        checkAll,
        // tabs
        setActiveTab,
        getActiveTab,
        // active customer / distributor
        getActiveCustomer,
        setActiveCustomer,
        getActiveDistributor,
        setActiveDistributor,
    };
});
